import { Check, Circle } from "lucide-react";

import { passwordRules } from "@/lib/password-policy";

import { cx } from "./cx";

/**
 * The password policy as a checklist under a new-password field, updated on every keystroke. Each row
 * pairs an icon shape with "met"/"not met" text for screen readers, so colour is never the only cue.
 * Point the input's `aria-describedby` at `id`.
 */
export function PasswordRequirements({
  id,
  password,
  email,
}: {
  id: string;
  password: string;
  email?: string;
}) {
  const rules = passwordRules(password, email);
  const met = rules.filter((r) => r.met).length;
  return (
    <div>
      <ul id={id} aria-label="Password requirements" className="space-y-1">
        {rules.map((rule) => (
          <li
            key={rule.id}
            className={cx(
              "flex items-start gap-1.5 text-xs",
              rule.met ? "text-emerald-700 dark:text-emerald-400" : "text-fg-subtle",
            )}
          >
            {rule.met ? (
              <Check className="mt-px size-3.5 shrink-0" strokeWidth={3} aria-hidden />
            ) : (
              <Circle className="mt-px size-3.5 shrink-0" aria-hidden />
            )}
            <span>
              {rule.label}
              <span className="sr-only">{rule.met ? " (met)" : " (not met)"}</span>
            </span>
          </li>
        ))}
      </ul>
      <p className="sr-only" aria-live="polite">
        {password ? `${met} of ${rules.length} password requirements met` : ""}
      </p>
    </div>
  );
}
